import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FireDepartmentService } from '../../../services';
import { useAppSelector } from '../../../store/hooks';
import { selectIsSuperAdmin } from '../../../store/reducers';
import type { FireDepartment } from '../../../types';
import { SimpleListItem } from '../../atoms';

export function Departments(): React.JSX.Element {
  const navigate = useNavigate();
  const isSuperAdmin = useAppSelector(selectIsSuperAdmin);

  const [isLoading, setIsLoading] = React.useState(true);
  const [departments, setDepartments] = React.useState<FireDepartment[]>([]);

  const loadFireDepartments = async (): Promise<void> => {
    const fireDepartmentResponse = await FireDepartmentService.getAllFireDepartments();
    if (fireDepartmentResponse.error) {
      toast.error('Fehler beim Laden der Feuerwehren 😩');
      console.log(fireDepartmentResponse.message);

      return;
    }
    setDepartments(fireDepartmentResponse.data as FireDepartment[]);
    setIsLoading(false);
  };

  const handleAddButton = () => {
    navigate('add');
  };

  useEffect(() => {
    loadFireDepartments().then(() => {});
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={'container mt-10'}>
      {isSuperAdmin && (
        <div className='row mb-3'>
          <div className='col-12 d-flex justify-content-end'>
            <Button variant='success' onClick={handleAddButton}>
              Hinzufügen
            </Button>
          </div>
        </div>
      )}
      <div className='row'>
        {departments.map((department) => (
          <div className='col-12 mb-2' key={`container-${department.id}`}>
            <SimpleListItem key={department.id} link={`/abteilung/${department.id}`}>
              {department.name}
            </SimpleListItem>
          </div>
        ))}
      </div>
    </div>
  );
}
